export default "__VITE_ASSET__BZjvQSxD__"